// export const BASE_URL = 'http://localhost:5000/';
export const BASE_URL = 'https://proshop-back.onrender.com/';
// export const GRAPHQL_BASE_URL = 'http://localhost:5000/graphql';
export const GRAPHQL_BASE_URL = 'https://proshop-back.onrender.com/graphql';
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const ADD_PRODUCT_URL = '/api/addProduct';
export const DELIVERY_URL = '/api/delivery';
export const stripeApiKey = 'pk_test_51N2bqvSIEzY742rCaQ3y1M91nSKmitoa3HOsUSul3FIXMuK05wIfNoAYELsqIdcPH9dUXrCj4qrnz0ECGphgbD3E0008FjK9LM'